// Function to initialize FAQ accordion functionality
export function initializeFAQSection(container?: HTMLElement | null) {
    const accordionGroups = container 
        ? container.querySelectorAll('.accrodion-grp')
        : document.querySelectorAll('.accrodion-grp');
    
    if (accordionGroups.length === 0) {
        return;
    }

    const jQuery = (window as any).jQuery;
    if (typeof jQuery === 'undefined') {
        // Retry if jQuery not loaded yet
        setTimeout(() => initializeFAQSection(container), 500);
        return;
    }

    try {
        accordionGroups.forEach((group) => {
            const $group = jQuery(group);
            const accrodionName = $group.data('grp-name');
            const $accordions = $group.find('.accrodion');
            
            // Add group name class
            $group.addClass(accrodionName);
            
            // Hide all content initially except active ones
            $group.find('.accrodion .accrodion-content').hide();
            $group.find('.accrodion.active .accrodion-content').show();
            
            // Set up click handlers
            $accordions.each(function(this: HTMLElement) {
                const $accordion = jQuery(this);
                const $title = $accordion.find('.accrodion-title');
                
                $title.off('click').on('click', function() {
                    if (!$accordion.hasClass('active')) {
                        // Remove active from all accordions in this group
                        $group.find('.accrodion').removeClass('active');
                        $group.find('.accrodion-content').slideUp();
                        
                        // Add active to clicked accordion
                        $accordion.addClass('active');
                        $accordion.find('.accrodion-content').slideDown();
                    }
                });
            });
        });
        
    } catch (error) {
    }
}

// Expose function globally for use in other scripts
if (typeof window !== 'undefined') {
    (window as any).initializeFAQSection = initializeFAQSection;
}

